window.theme = window.theme || {};
theme.cartDrawer = (function($) {
  'use strict';
  var $root = $('[data-cart-drawer]').first();
  if (!$root.length) return null;
  var $panel = $root.find('[role="dialog"]');
  var $content = $root.find('[data-cart-drawer-content]');
  var $status = $root.find('[data-cart-drawer-status]');
  var $error = $root.find('[data-cart-drawer-error]');
  var opener = null, background = [], busy = false, stale = false, version = 0;
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var sectionId = $root.attr('data-section-id') || 'cart-drawer';
  // Render in the current page context: cart pages own the visible wallets;
  // on other pages the drawer owns them. Preserve that choice after updates.
  var cartContext = new URL(window.location.pathname, window.location.origin);
  var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (!previewId && window.Shopify && Shopify.theme && Shopify.theme.role === 'unpublished') previewId = String(Shopify.theme.id);
  if (previewId && /^\d+$/.test(previewId)) cartContext.searchParams.set('preview_theme_id', previewId);
  var sectionsUrl = cartContext.pathname + cartContext.search;

  function text(name) { return $root.attr('data-' + name) || ''; }
  function isOpen() { return !$root.prop('hidden'); }
  function dirty() {
    var changed = false;
    $content.find('[data-cart-drawer-quantity]').each(function() {
      if (this.value !== $(this).attr('data-current-quantity')) changed = true;
    });
    return changed;
  }
  function state() {
    if (isOpen() && (busy || stale) && $content[0].contains(document.activeElement)) {
      $panel.find('.oere-cart-drawer__close')[0].focus();
    }
    $content.attr('aria-busy', busy ? 'true' : 'false');
    $root.find('[data-cart-drawer-fallback]').prop('hidden', busy || !stale);
    $content.find('[data-cart-drawer-quantity], [data-cart-drawer-remove]').prop('disabled', busy || stale);
    $content.find('[data-cart-drawer-checkout]').prop('hidden', busy || stale || dirty());
    $content.find('[data-cart-drawer-unsaved]').prop('hidden', !dirty());
  }
  function show(trigger) {
    if (isOpen()) return;
    opener = trigger || document.activeElement;
    $root.prop('hidden', false);
    $panel.find('.oere-cart-drawer__close')[0].focus();
    background = [];
    Array.prototype.forEach.call(document.body.children, function(element) {
      if (element.contains($root[0]) || /^(SCRIPT|STYLE|LINK)$/.test(element.tagName)) return;
      background.push({element:element, inert:element.inert, aria:element.getAttribute('aria-hidden')});
      element.inert = true;
      element.setAttribute('aria-hidden', 'true');
    });
    $('html').addClass('oere-cart-drawer-open');
    $('.site-header__cart').attr('aria-expanded', 'true');
  }
  function close() {
    if (!isOpen()) return;
    $root.prop('hidden', true);
    $('html').removeClass('oere-cart-drawer-open');
    background.forEach(function(entry) {
      entry.element.inert = entry.inert;
      if (entry.aria === null) entry.element.removeAttribute('aria-hidden');
      else entry.element.setAttribute('aria-hidden', entry.aria);
    });
    background = [];
    $('.site-header__cart').attr('aria-expanded', 'false');
    if (opener && document.documentElement.contains(opener) && !opener.disabled) opener.focus();
    else if ($('.site-header__cart').length) $('.site-header__cart')[0].focus();
  }
  function render(sections, announcement, errorMessage) {
    var html = sections && sections[sectionId];
    if (typeof html !== 'string') return false;
    var $fragment = $('<div></div>').append($.parseHTML(html, document, false));
    var $newContent = $fragment.find('[data-cart-drawer-content]').first();
    if (!$newContent.length || !/^\d+$/.test($newContent.attr('data-item-count') || '') || /Liquid error:/i.test($newContent.text())) return false;
    var restoreFocus = isOpen() && $content[0].contains(document.activeElement);
    $content.html($newContent.html()).attr('data-item-count', $newContent.attr('data-item-count')).prop('hidden', false);
    var count = $newContent.attr('data-item-count');
    $root.find('[data-cart-drawer-count]').text(count);
    $('#CartCount').text(count);
    busy = false; stale = false;
    $status.text(announcement || text('loaded'));
    $error.text(errorMessage || '').prop('hidden', !errorMessage);
    state();
    if (restoreFocus) $panel.find('.oere-cart-drawer__close')[0].focus();
    return true;
  }
  function refresh(announcement, errorMessage) {
    var current = ++version;
    busy = true; stale = true;
    state();
    $content.prop('hidden', true);
    $status.text(text('loading'));
    $error.prop('hidden', true);
    state();
    function failed() {
      if (current !== version) return;
      busy = false; stale = true;
      $content.prop('hidden', true);
      $status.text(announcement || '');
      $error.text(errorMessage || text('load-error')).prop('hidden', false);
      state();
    }
    function loadPage() {
      if (current !== version) return;
      // A missing section response must not leave a working full cart page inaccessible.
      // This is a read only fallback; add/change requests are never repeated here.
      $.ajax({url:sectionsUrl, type:'get', dataType:'html', timeout:15000, cache:false,
        success:function(html) {
          if (current !== version) return;
          var page = new DOMParser().parseFromString(html, 'text/html');
          var content = page.querySelector('[data-cart-drawer-content]');
          var sections = {};
          sections[sectionId] = content ? content.outerHTML : null;
          if (!render(sections, announcement, errorMessage)) failed();
        }, error:failed
      });
    }
    $.ajax({url:sectionsUrl, type:'get', dataType:'json', timeout:15000, cache:false, data:{sections:sectionId},
      success:function(sections) { if (current === version && !render(sections, announcement, errorMessage)) loadPage(); },
      error:loadPage
    });
  }
  function responseError(xhr) {
    var data = xhr.responseJSON;
    if (!data && xhr.responseText) {
      try { data = JSON.parse(xhr.responseText); } catch (error) { data = null; }
    }
    return data && typeof data.description === 'string' ? data.description : text('change-error');
  }
  function change($line, quantity) {
    if (busy || stale) return;
    busy = true; stale = true; ++version;
    $status.text(text('loading'));
    $error.prop('hidden', true);
    state();
    $.ajax({url:routeRoot+'cart/change.js', type:'post', dataType:'json', timeout:15000,
      data:{id:$line.attr('data-key'),quantity:quantity,sections:sectionId,sections_url:sectionsUrl},
      success:function(cart) {
        if (!render(cart.sections, text('loaded'))) refresh(text('loaded'));
      },
      error:function(xhr) {
        // Re-read the cart after an uncertain response; never repeat a mutation automatically.
        refresh('', responseError(xhr));
      }
    });
  }
  $root.on('click.cartDrawer', '[data-cart-drawer-close]', close);
  $root.on('input.cartDrawer', '[data-cart-drawer-quantity]', state);
  $root.on('change.cartDrawer', '[data-cart-drawer-quantity]', function() {
    if (busy || stale) return;
    if (!this.checkValidity() || !/^\d+$/.test(this.value) || Number(this.value) < 1) {
      $error.text(text('invalid-quantity')).prop('hidden', false);
      this.reportValidity(); state(); return;
    }
    if (this.value !== $(this).attr('data-current-quantity')) change($(this).closest('[data-cart-drawer-line]'), Number(this.value));
  });
  $root.on('keydown.cartDrawer', '[data-cart-drawer-quantity]', function(event) {
    if (event.key === 'Enter') { event.preventDefault(); $(this).trigger('change'); }
  });
  $root.on('click.cartDrawer', '[data-cart-drawer-remove]', function() {
    change($(this).closest('[data-cart-drawer-line]'), 0);
  });
  $root.on('submit.cartDrawer', '.oere-cart-drawer__checkout form', function(event) {
    if (busy || stale || dirty()) event.preventDefault();
  });
  $(document).on('click.cartDrawer', '.site-header__cart', function(event) {
    if (event.which > 1 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); show(this);
    if (!busy) refresh();
  });
  $(document).on('keydown.cartDrawer', function(event) {
    if (!isOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var $focusable = $panel.find('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(':visible');
    var first = $focusable[0], last = $focusable[$focusable.length-1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === $panel[0])) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  $(document).on('focusin.cartDrawer', function(event) {
    if (isOpen() && !$panel[0].contains(event.target)) $panel.find('.oere-cart-drawer__close')[0].focus();
  });
  $('.site-header__cart').attr({'aria-controls':'OereCartDrawerDialog','aria-expanded':'false','aria-haspopup':'dialog'});
  return {
    sectionsUrl:sectionsUrl,
    sectionId:sectionId,
    beginAdd:function(trigger) {
      if (busy) { show(trigger); return false; }
      busy = true; stale = true; ++version;
      $content.prop('hidden', true);
      $status.text(text('loading'));
      $error.prop('hidden', true);
      state(); return true;
    },
    endAdd:function() { busy = false; state(); },
    onAdded:function(data, trigger) {
      show(trigger);
      if (!render(data && data.sections, text('added'))) refresh(text('added'));
    },
    open:function(trigger) { show(trigger); if (!busy) refresh(); },
    close:close
  };
})(jQuery);
